module.exports = __webpack_public_path__ + "img/highlight.3f0b60b2.svg";